/**
 * Удаляет расширение из имени файла, если оно есть в списке допустимых расширений.
 *
 * @param {string} filename - Имя файла.
 * @param {string[]} extensions - Список допустимых расширений (без точки).
 * @returns {string} - Имя файла без расширения.
 */
export function removeFileExtension(filename: string, extensions: string[]) {
    const sortedExtensions = extensions.slice().sort((a, b) => b.length - a.length);

    const escapedExtensions = sortedExtensions.map((ext) =>
        ext.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
    );

    const regex = new RegExp(`\\.(${escapedExtensions.join('|')})$`, 'i');

    return filename.replace(regex, '');
}
